module.exports = __webpack_public_path__ + "static/media/mini_calc_image.ebeafa61.png";